import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'payment-resume-pay-button-button-element',
    templateUrl: './payment.resume.pay-button.button-element.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentResumePayButtonButtonElementComponent {
    @Output('ready') ready: EventEmitter<null> = new EventEmitter();
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/payment/resume/pay-button/button-element/payment.resume.pay-button.button-element.component.ts